import { Injectable } from '@angular/core';
import { AlertController, NavController } from '@ionic/angular';
import { AlertService } from './alert.service';
import { Observable } from 'rxjs';
import { API_SETTINGS } from '../api-services/API_SETTINGS';
import { HttpClient } from '@angular/common/http';
import { ApiCustomerUsageService } from '../api-services/customer-usage.api.service';
import { User } from '../models/User';
import { MessagesService } from './messages.service';
import { CryptoService } from './crypto.service';
import { AuthenticationService } from './authentication.service';
import { CustomerUsageService } from './customer-usage.service';
import { StorageService } from './storageService.service';
@Injectable({
  providedIn: 'root'
})
export class UsersService {
  public users = [];
  public usersDisabled = false;
  public displayEmulator = false;

  public userFilters = {
    userName: '',
    email: '',
    role: '',
  };


  constructor(
    public alertController: AlertController,
    public alertService: AlertService,
    public navController: NavController,
    public httpClient: HttpClient,
    public apiCustomerUsageService: ApiCustomerUsageService,
    public messageService: MessagesService,
    public cryptoService: CryptoService,
    public authService: AuthenticationService,
    public customerUsageService: CustomerUsageService,
    public storageService: StorageService
  ) {
    this.getUsers();
  }

  communicateApi(urlParams): Observable<any> {
    var url = API_SETTINGS.API_URL + urlParams;
    return this.httpClient.get<any>(url);
  }

  getUsers(): Promise<void> {
    return new Promise<void>((resolve) => {
      if(!this.cryptoService.decryptData(this.storageService.getItem('customerId'))){
        resolve();
        return;
      }
      
      this.communicateApi("customer/GetUsersByCustomerId/" + this.cryptoService.decryptData(this.storageService.getItem('customerId'))).subscribe(res => {
        this.users = res;

        let user = this.users.filter(x => String(x.email).toLowerCase() == String(this.cryptoService.decryptData(this.storageService.getItem("login_email"))).toLowerCase())[0];
        if(!user){
          this.messageService.presentToast("Something went wrong, you have been logged out!", "warning", "eNetReality™");
          this.authService.logOut();          
        }
        resolve();
      });
    });
  }

  async presentUpsertProfile(email) {
    const alert = await this.alertController.create({
      header: 'My Profile',
      message: "Update your email address below, or supply your existing and new password to update your accounts password. <br/><br/><cite>Please note, that if your current password, or the two new password fields are incorrect your password will not be updated. Also, if you update your email address you will be required to participate in a two factor authentication check.</cite>",
      inputs: [
        {
          name: 'email',
          type: 'email',
          label: 'User email address:',
          placeholder: 'User email address.',
          value: email
        },
        {
          name: 'oldPassword',
          type: 'password',
          placeholder: 'Old password.',
          value: ""
        },
        {
          name: 'newPassword',
          type: 'password',
          placeholder: 'New password.',
          value: ""
        },
        {
          name: 'confirmNewPassword',
          type: 'password',
          placeholder: 'Confirm new password.',
          value: ""
        }
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {

          }
        }, {
          text: 'Save',
          handler: (data) => {
            this.communicateApi("authentication/updateprofile/" + email + "/" + data.email + "/" + data.oldPassword + "/" + data.newPassword + "/" + data.confirmNewPassword).subscribe(res => {
              this.storageService.setItem("login_email", this.cryptoService.encryptData(data.email));
            });
          }
        }
      ]
    });

    await alert.present();
  }

  async presentUpsertUser(user) {
    const alert = await this.alertController.create({
      header: user != null ? 'Edit ' + user.userName : 'Add New User',
      inputs: [
        {
          name: 'userName',
          type: 'text',
          label: 'User full name:',
          placeholder: 'User full name.',
          value: user != null ? user.userName : ""
        },
        {
          name: 'email',
          type: 'email',
          placeholder: 'User email.',
          value: user != null ? user.email : ""
        }
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {

          }
        }, {
          text: user != null ? 'Save' : 'Add',
          handler: (data) => {
            //console.log(JSON.stringify(data));
            var userData = {
              "userId": user != null ? user.userId : this.users.length,
              "userName": data.userName,
              "email": data.email,
              "role": user != null ? user.role : "Author",
              "active": true
            };

            if (user != null) {
              this.communicateApi("authentication/update/" + userData.userId + "/" + userData.userName + "/" + userData.email + "/" + this.cryptoService.decryptData(this.storageService.getItem('customerId')) + "/" + userData.role).subscribe(res => {
                this.getUsers();
                this.messageService.presentToast('User saved successfully!', 'success', 'Admins & Authors');
                //this.messageService.displayToastWithMessage('', 'User updated successfully, the user will need to log out and back in to receive any role changes.');
              });
            }
            else {
              this.communicateApi("authentication/create/" + userData.userName + "/" + userData.email + "/" + this.cryptoService.decryptData(this.storageService.getItem('customerId')) + "/" + userData.role).subscribe(res => {
                this.getUsers();
                this.messageService.presentToast('New user saved successfully!', 'success', 'Admins & Authors');
                //this.messageService.displayToastWithMessage('', 'User added successfully, the user will need to log out and back in to receive any role changes.');
              });
            }
          }
        }
      ]
    });

    await alert.present();
  }

  async launchUser(user) {

  }

  async addUser(user: User) {
    await this.messageService.presentLoadingWindow('Adding User...').then(async x => {
      let customerId: number = Number(this.cryptoService.decryptData(this.storageService.getItem('customerId')));
      this.customerUsageService.customerUsage.userUsage++;
      await this.communicateApi("authentication/create/" + user.userName + "/" + user.email + "/" + customerId + "/" + user.role).subscribe(res => {
        this.getUsers();
        this.customerUsageService.getCustomerUsage(customerId);
        this.messageService.loadingWindow.dismiss();
        this.messageService.presentToast('New user saved successfully!', 'success', 'Admins & Authors');
        //this.messageService.displayToastWithMessage('', 'User added successfully, the user will need to log out and back in to receive any role changes.');
      });
    })

  }

  async updateUser(user: User) {
    await this.messageService.presentLoadingWindow('Updating User...').then(async x => {
      await this.communicateApi("authentication/update/" + user.userId + "/" + user.userName + "/" + user.email + "/" + this.cryptoService.decryptData(this.storageService.getItem('customerId')) + "/" + user.role).subscribe(res => {
        this.getUsers();
        this.messageService.loadingWindow.dismiss();
        this.messageService.presentToast('User saved successfully!', 'success', 'Admins & Authors');
      });
    });

  }

  async updateUserProfile(user: User, updateEmail: boolean) {
    await this.messageService.presentLoadingWindow('Updating Profile...').then(async x => {
      await this.communicateApi("authentication/update/" + user.userId + "/" + user.userName + "/" + user.email + "/" + this.cryptoService.decryptData(this.storageService.getItem('customerId')) + "/" + user.role).subscribe(res => {
        this.storageService.setItem("login_email", this.cryptoService.encryptData(user.email));
        this.getUsers();
        this.messageService.loadingWindow.dismiss();
        this.messageService.presentToast('Profile saved successfully!', 'success', 'My Profile');
        if (updateEmail) {
          this.messageService.presentLoadingWindow("Logging you out...");
          setTimeout(() => {
            this.messageService.loadingWindow.dismiss();
            this.authService.logOut();
          }, 3000);
        }
      });
    });

  }

  async updatePassword(user, old, newPassword, confirmed) {
    await this.messageService.presentLoadingWindow('Updating Password...').then(async x => {
      old = encodeURIComponent(old);
      newPassword = encodeURIComponent(newPassword);
      confirmed = encodeURIComponent(confirmed);
      await this.communicateApi("authentication/updateprofile/" + user.email + "/" + user.email + "/" + old + "/" + newPassword + "/" + confirmed).subscribe(res => {
        this.messageService.loadingWindow.dismiss();
        this.messageService.presentToast('Password saved successfully!', 'success', 'My Profile');
      });
    });
  }

  async updateUserRole(user, role) {
    const alert = await this.alertController.create({
      header: 'Please confirm',
      message: "are you sure you want to update " + user.userName + "'s role to " + role + "?",
      buttons: [{
        text: 'Cancel',
      }, {
        text: 'Update Role',
        handler: () => {
          user.role = role;
          this.communicateApi("authentication/update/" + user.userId + "/" + user.userName + "/" + user.email + "/" + this.cryptoService.decryptData(this.storageService.getItem('customerId')) + "/" + user.role).subscribe(res => {
            this.getUsers();
            this.messageService.presentToast('User saved successfully!', 'success', 'Admins & Authors');
            //this.messageService.displayToastWithMessage('', 'User updated successfully, the user will need to log out and back in to receive any role changes.');
          });
        }
      }
      ]
    });
    await alert.present();
  }

  async deleteUser(user) {
    const alert = await this.alertController.create({
      header: 'Please confirm',
      message: "are you sure you want to delete the user '" + user.userName + "'?",
      buttons: [{
        text: 'Cancel',
      }, {
        text: 'Delete',
        handler: () => {
          this.messageService.presentLoadingWindow("Deleting User...").then(x => {
            let customerId: number = Number(this.cryptoService.decryptData(this.storageService.getItem('customerId')));
            this.customerUsageService.customerUsage.userUsage--;
            this.communicateApi("authentication/delete/" + user.userId).subscribe(res => {
              this.getUsers();
              this.customerUsageService.getCustomerUsage(customerId);
              this.messageService.loadingWindow.dismiss();
              this.messageService.presentToast('User deleted successfully!', 'success', 'Users');

              if(String(user.email).toLowerCase() == String(this.cryptoService.decryptData(this.storageService.getItem("login_email"))).toLowerCase()){
                this.logoutUser();
              }
            });
          })
        }
      }
      ]
    });
    await alert.present();
  }

  async logoutUser() {
    this.storageService.clear();

    var logoutTimeout = setTimeout(() => {
      this.alertController.dismiss();
      this.authService.logOut();
    }, 10000);

    const alert = await this.alertController.create({
      header: 'Log out',
      backdropDismiss: false,
      message: "Your user was deleted, you will be automatically logged out.",
      buttons: [{
        text: 'Log out',
        handler: () => {
          clearTimeout(logoutTimeout);
          this.authService.logOut();
        }
      }
      ]
      
    });
    await alert.present();
  }
}
